import React from "react"
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { AuthContext } from '../../main/ProvedorAutenticacao'
import ReactToPrint from "react-to-print";

import './documentos.css'

class ComponentToPrintContratoPrestacaoServico extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dataImpressao: ''
    }
  }

  componentDidMount() {
    var monName = new Array ("janeiro", "fevereiro", "março", "abril", "Maio", "junho", "agosto", "outubro", "novembro", "dezembro")
    var data = new Date();
    var dataCompleta = "João Pessoa, " + data.getDate () + " de " + monName [data.getMonth() ]   +  " de "  +     data.getFullYear ()
    this.setState({dataImpressao: dataCompleta});
  }

  render() {
    return(
      <>
        <div>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
            <div style={{textAlign: 'center'}} className="titulo">
              <h3><strong>CONTRATO DE PRESTAÇÃO DE SERVIÇOS ADVOCATÍCIOS</strong></h3>
            </div>
            <br/>
            <br/>
            <div>
              <div style={{textAlign: 'center'}}>
                <p className="kleiton">
                  <h4>
                    <strong>CONTRATANTE:</strong> {this.props.nomePessoa}, {this.props.nacionalidade}, {this.props.estadoCivil}, {this.props.profissao}, identidade nº. {this.props.rg}, CPF nº.: {this.props.cpf}, 
                    residente e domiciliado na Rua {this.props.endereco}, nº. {this.props.numero}, {this.props.bairro}, {this.props.cidade} - {this.props.estado}, CEP: {this.props.cep}.
                  </h4>
                  <br></br>
                  <h4>
                    <strong>CONTRATADOS: RODRIGO MAGNO NUNES MORAES</strong>, brasileiro, casado, advogado, inscrito na OAB/PB sob o nº 14798, inscrito no CPF/MF sob nº 057.010.604-46 
                    e <strong>ANNE KARINE RODRIGUES MORAES</strong>, brasileira, casada, advogada, inscrita na OAB/PB sob o nº 23.573, 
                    ambos com endereço profissional na Avenida João Machado, nº553, Sala 617, 6º andar, 
                    Empresarial Plaza Center, Centro, João Pessoa – Paraíba, CEP 58.013-520, e-mail: rm_advogados@hotmail.com.
                  </h4>
                  <br></br>
                  <h4>
                    <strong>
                      As partes acima identificadas têm, entre si, justo e acertado, 
                      o presente Contrato de Honorários Advocatícios, que se regerá pelas cláusulas 
                      seguintes e pelas condições descritas no presente.
                    </strong>
                  </h4>
                  <br></br>
                  <h4>
                    <strong>CLÁUSULA PRIMEIRA:</strong> O presente contrato de prestação de serviços advocatícios por parte do escritório constituído, 
                    tem por objetivo propor Ação de Declaratória c/c Danos morais, perante a justiça competente.
                  </h4>
                  <br></br>
                  <h4>
                    <strong>Parágrafo Único:</strong> Nesta oportunidade, o cliente foi esclarecido de que são de sua 
                    responsabilidade todas as despesas judiciais para diligências e os recursos posteriores, 
                    se necessários, e custas finais, se houver. 
                  </h4>
                  <br></br>
                  <h4>
                    <strong>CLÁUSULA SEGUNDA:</strong> Em remuneração aos serviços profissionais contidos na cláusula primeira, 
                    o Constituinte pagará, ao escritório, ao final do processo a importância de 30% do valor da sentença, 
                    inclusive na hipótese de acordo judicial ou extrajudicial.
                  </h4>
                  <br></br>
                  <h4>
                    <strong>PARAGRAFO PRIMEIRO:</strong> Em caso de desistência da demanda por parte do cliente, 
                    fica estipulada uma multa de 01 (um) salário mínimo vigente, a título de honorários advocatícios.
                  </h4>
                  <br></br>
                  <h4>
                    <strong>CLÁUSULA TERCEIRA:</strong> O Constituinte ficará na obrigação de fornecer ao Constituído, 
                    na forma do Estatuto da Advocacia, todos os documentos e provas necessárias à defesa de seus direitos, 
                    fornecer endereços para citações e intimações, bem como a pagar todas as despesas e 
                    custas judiciais ou extrajudiciais para os atos não previstos neste contrato. 
                  </h4>
                  <br></br>
                  <h4>
                    <strong>Parágrafo único.</strong> Nos termos deste contrato, o escritório se obriga a propor as medidas e 
                    todos os atos previstos neste contrato e cumprir com esmero os seus deveres de patronesse. 
                  </h4>
                  <br></br>
                  <h4>
                    <strong>CLÁUSULA QUARTA:</strong> As partes elegem o foro de João Pessoa-PB, renunciando a outros por mais privilegiados 
                    que sejam para dirimir as questões oriundas deste contrato. 
                    E, por estarem de acordo, declaram as partes que aceitam todas as disposições estabelecidas 
                    nas cláusulas deste contrato, bem como que observarão fielmente as disposições legais 
                    e regulamentos pertinentes, pelo qual firmam o presente termo em 02 (duas) vias de igual teor 
                    e único efeito, na presença de testemunhas. 
                  </h4>
                  <br></br>
                  <br></br>
                  <h4 className="data">
                    <strong>{this.state.dataImpressao}</strong>
                  </h4>
                  <br></br>
                  <br></br>
                  <br></br>
                  <h4 className="data">
                    <strong>CONSTITUINTE:</strong> _______________________________________
                    <br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{this.props.nomePessoa}
                  </h4>
                  <br></br>
                  <h4 className="data">
                    <strong>CONSTITUIDOS:</strong> ________________________________________
                    <br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;RODRIGO MAGNO NUNES MORAES
                    <br/>
                    <br/>
                    <strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong> ________________________________________
                    <br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ANNE KARINE RODRIGUES MORAES
                  </h4>
                  <br></br>
                  <br></br>
                  <br></br>
                </p>
              </div>
            </div>
        </div>
      </>
    );
  }
}

class ContratoPrestacaoServico extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      nomePessoa: '',
      nacionalidade: '',
      estadoCivil: '',
      profissao: '',
      rg: '',
      cpf: '',
      endereco: '',
      numero: '',
      bairro: '',
      cidade: '',
      estado: '',
      cep: ''
    }
  }

  componentDidMount() {
    const params = this.props.match.params;
    this.setState({nomePessoa: params.nomePessoa});
    this.setState({nacionalidade: params.nacionalidade});
    this.setState({estadoCivil: params.estadoCivil});
    this.setState({profissao: params.profissao});
    this.setState({rg: params.rg});
    this.setState({cpf: params.cpf});
    this.setState({endereco: params.endereco});
    this.setState({numero: params.numero});
    this.setState({bairro: params.bairro});
    this.setState({cidade: params.cidade});
    this.setState({estado: params.estado});
    this.setState({cep: params.cep});
  }

  render() {
    return (
      <div style={{textAlign: 'center'}}>
        <br></br>
        <br></br>
        <br></br>
        <ReactToPrint
          trigger={() => <a className="cursor" >Imprimir</a>}
          content={() => this.componentRef}>
        </ReactToPrint>
        <ComponentToPrintContratoPrestacaoServico nomePessoa={this.state.nomePessoa}
                  nacionalidade={this.state.nacionalidade}
                  estadoCivil={this.state.estadoCivil}
                  profissao={this.state.profissao}
                  rg={this.state.rg}
                  cpf={this.state.cpf}
                  endereco={this.state.endereco}
                  numero={this.state.numero}
                  bairro={this.state.bairro}
                  cidade={this.state.cidade}
                  estado={this.state.estado}
                  cep={this.state.cep}
                ref={el => (this.componentRef = el)} />
      </div>
    );
  }
}

ContratoPrestacaoServico.contextType = AuthContext;
export default ContratoPrestacaoServico;